import React from 'react';
import { nationality } from 'further-ui/labels';
import { Control, Controller, useFieldArray } from 'react-hook-form';

import AppCheckbox from 'components/FormElements/AppCheckBox';
import AppSelectBox from 'components/FormElements/AppSelectBox';
import FieldRow from 'components/FormElements/FieldRow';
import { IconButton } from '@mui/material';
import { AddOutlined, Remove } from '@mui/icons-material';
import { InvestorFormValues } from 'helpers/investor/investorForm';
import { Row } from 'components/Layout';

type Props = {
  control: Control<InvestorFormValues>;
};

const InvestorNationality: React.FC<Props> = ({ control }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'otherNationality',
  });

  return (
    <>
      <FieldRow title="Nationality*" centerTitle>
        <Controller
          name="nationality"
          control={control}
          render={({ field: { ref, ...rest }, fieldState: { error } }) => (
            <AppSelectBox
              {...rest}
              data={nationality}
              valueKey="Country"
              labelKey="Country"
              variant="outlined"
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </FieldRow>
      <FieldRow title="" centerTitle>
        <AppCheckbox
          key="isOtherNationality"
          label="This is the investor’s only nationality"
          checked={!fields.length}
          onChange={(event) => {
            if (event.target.checked) {
              for (let i = fields.length - 1; i >= 0; i--) {
                remove(i);
              }
            } else {
              append({ country: '' });
            }
          }}
        />
      </FieldRow>
      {fields.map((field, i) => (
        <React.Fragment key={field.id}>
          <FieldRow title="Other nationality" key={i} centerTitle>
            <Row centered spacing="xs">
              <Controller
                name={`otherNationality.${i}.country`}
                control={control}
                render={({
                  field: { ref, ...rest },
                  fieldState: { error },
                }) => (
                  <AppSelectBox
                    {...rest}
                    data={nationality}
                    valueKey="Country"
                    labelKey="Country"
                    variant="outlined"
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
              <IconButton onClick={() => append({ country: '' })} size="large">
                <AddOutlined />
              </IconButton>
              <IconButton onClick={() => remove(i)} size="large">
                <Remove />
              </IconButton>
            </Row>
          </FieldRow>
        </React.Fragment>
      ))}
    </>
  );
};
export default InvestorNationality;
